import React, { useState } from "react";
import styled from "styled-components";

import SideIcons from "./side-icons";
import LibraryNavigation from "./library";
import ServerNavigation from "./server";
import ImportNavigation from "./import";
import ProfileNavigation from "./profile";
import PlayerNavigation from "./player";
import { Text, Col } from "../../comps";
import { COLORSCHEME } from "../../theme/color";
import { NAVBAR } from "../../theme/dimensions";
import { NAV_OPTIONS } from "../../constants";
import { Theme } from "../../theme/theme-provider";
import { menuBlue, menuGray } from "../../theme/image";

const NavbarWrapper = styled.div`
  width: ${({ width }) => width + "px"};
  height: ${({ navClosed }) => (navClosed ? "10vh" : "100vh")};
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
  background-color: ${COLORSCHEME.BLACK_1};
  transition: width 500ms ease;
  display: flex;
  flex-direction: row;
  flex-shrink: 0; /**Most important if its inside a flex */
`;

const RouterWrapper = styled.div`
  height: 100%;
  width: ${({ width }) => width + "px"};
  /* flex: 0 0 76%; */
  flex-shrink: 0;
  box-sizing: border-box;
  background-color: ${COLORSCHEME.BLACK_2};
`;

const IconWrapper = styled(Col)`
  width: 100%;
  height: ${NAVBAR.SIDE_ICON_SIZE + 40}px;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
    background-color: ${COLORSCHEME.BLACK_2};
  }
`;

const AnimatedImg = styled.img`
  width: ${({ width }) => width + "px"};
  height: ${({ height }) => height + "px"};
  transition: position 1s ease;
`;

const AnimatedText = styled(Text)`
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 1s ease;
`;

const ClosedNav = ({ openNav }) => {
  const [hover, setHover] = useState(false);

  return (
    <NavbarWrapper width={NAVBAR.SIDE_WIDTH} navClosed={true}>
      <IconWrapper
        onMouseEnter={() => {
          setHover(true);
        }}
        onMouseLeave={() => {
          setHover(false);
        }}
        onClick={openNav}
      >
        <AnimatedImg
          width={NAVBAR.SIDE_ICON_SIZE}
          height={NAVBAR.SIDE_ICON_SIZE}
          src={hover ? menuBlue : menuGray}
        />
        <AnimatedText
          fontSize="12px"
          fontWeight="500"
          color={Theme.color.BLUE_3}
          visible={hover}
        >
          {`Drawer`}
        </AnimatedText>
      </IconWrapper>
    </NavbarWrapper>
  );
};

export default ({ isNavMin, setIsNavMin }) => {
  if (isNavMin)
    return (
      <ClosedNav
        isNavMin={isNavMin}
        openNav={() => {
          setIsNavMin(false);
        }}
      />
    );

  const [navDetails, setNavDetails] = useState({
    isNavOpen: false,
    navOption: -1,
  });
  const { isNavOpen, navOption } = navDetails;

  const mouseLeave = () => {
    if (isNavOpen)
      setNavDetails((prevNavDetails) => {
        return {
          ...prevNavDetails,
          isNavOpen: false,
          primaryHoverIndex: null,
        };
      });
  };

  const OptionsMapping = {};
  OptionsMapping[NAV_OPTIONS.PROFILE] = <ProfileNavigation />;
  OptionsMapping[NAV_OPTIONS.LIBRARY] = <LibraryNavigation />;
  OptionsMapping[NAV_OPTIONS.SERVER] = <ServerNavigation />;
  OptionsMapping[NAV_OPTIONS.IMPORT] = <ImportNavigation />;
  OptionsMapping[NAV_OPTIONS.PLAYER] = <PlayerNavigation />;

  return (
    <NavbarWrapper
      width={isNavOpen ? NAVBAR.FULL_WIDTH : NAVBAR.SIDE_WIDTH}
      onMouseLeave={mouseLeave}
    >
      <SideIcons
        navDetails={navDetails}
        setNavDetails={setNavDetails}
        closeNav={() => {
          setIsNavMin(true);
        }}
      />
      {isNavOpen && OptionsMapping[navOption] && (
        <RouterWrapper width={NAVBAR.FULL_WIDTH - NAVBAR.SIDE_WIDTH}>
          {OptionsMapping[navOption]}
        </RouterWrapper>
      )}
    </NavbarWrapper>
  );
};
